import React from 'react'

import clsx from 'clsx'

import ClickoutWrapper from 'components/ClickoutWrapper'
import Grid from 'components/Grid'
import HoverEvent from 'components/HoverEvent'
import Html from 'components/Html'
import Icon from 'components/Icon'
import Link from 'components/Link'
import Logo from 'components/Logo'
import Rating from 'components/Rating'
import { useAppContext } from 'context/AppContext'
import { useEventContext } from 'context/EventContext'
import { getengagementDestination } from 'helpers/reviews'
import RatedTag from 'screens/serp/components/SerpContentRich/components/RatedTag'

import classes from './Info.module.scss'

/** @type {import("./types").default} */
const Info = ({ className, listing, component = 'h2', listingPosition, ...props }) => {
  const { addEvent } = useEventContext({ engagementComponent: 'product_card-item' })
  const { route } = useAppContext()

  const isSerpPage = route?.includes('serp_')
  const highlyViewedEventString = listing.most_visited ? ' | highly-viewed' : ''

  return (
    <Grid container className={clsx('Info', classes.root, className)} {...props}>
      <Grid item xs={12} lg={7} className={classes.product}>
        <ClickoutWrapper
          url={isSerpPage ? listing.cta_urls.detail : listing.cta_urls.cta}
          isClickout={listing.is_premium && !isSerpPage}
          buyerIntentProductId={listing.global_product_id}
          buyerIntentSourceLocation="best-product/info:logo"
          buyerIntentTrackAdClick={listing.is_premium && !isSerpPage}
          data-testid="listing-item_logo_product"
          className={classes.logoContainer}
          listingPosition={listingPosition}
          {...addEvent({
            productClickPosition: listingPosition,
            engagementDetails: 'logo_product' + highlyViewedEventString,
            engagementDestination: listing.is_premium && !isSerpPage ? 'go-to_vendor-website' : 'go-to_product_details',
            name: listing.is_premium && !isSerpPage ? 'engagement_product_clickout' : 'engagement_product_click',
          })}
        >
          <Logo className={classes.logo} src={`${listing.logo_url}`} alt={`${listing.name} logo`} size={80} />
        </ClickoutWrapper>
        <div className={classes.info}>
          <div>
            <ClickoutWrapper
              isClickout={listing.is_premium}
              url={listing.cta_urls.cta}
              buyerIntentProductId={listing.global_product_id}
              buyerIntentSourceLocation="best-product/info:name"
              buyerIntentTrackAdClick={listing.is_premium}
              data-testid="listing-item_text-link_product-name"
              listingPosition={listingPosition}
              {...addEvent({
                productClickPosition: listingPosition,
                engagementDetails: 'text-link_product-name' + highlyViewedEventString,
                engagementDestination: listing.is_premium ? 'go-to_vendor-website' : 'go-to_product_details',
                name: listing.is_premium ? 'engagement_product_clickout' : 'engagement_product_click',
              })}
            >
              <Link className={classes.title} component={component}>
                <Html>{listing.name}</Html>
                {listing.is_premium && (
                  <Icon className={classes.clickoutIcon} icon={['far', 'external-link']} size="12" />
                )}
              </Link>
            </ClickoutWrapper>
          </div>
          <HoverEvent
            event={{
              engagementDestination: 'show_reviews-breakdown',
              engagementDetails: 'hover_icon',
            }}
          >
            <Rating.Link
              href={listing.cta_urls.reviews}
              average={listing.rating_avg}
              totals={listing.num_reviews}
              ratings={listing?.reviews?.by_rating}
              ratingsHrefs={listing?.reviews?.by_rating_urls}
              size="small"
              {...(listing.most_visited
                ? addEvent({
                    engagementDetails: 'data_overall-rating_stars' + highlyViewedEventString,
                    engagementDestination: getengagementDestination(listing.cta_urls.reviews, {
                      isListingDetail: route === 'listing_detail',
                    }),
                    name: 'engagement_product_click',
                  })
                : {})}
            />
          </HoverEvent>
        </div>
      </Grid>

      {listing?.highly_rated_for && (
        <Grid item xs={12} lg={5} className={classes.highlyRatedFor}>
          <RatedTag tagKey={listing.highly_rated_for} />
        </Grid>
      )}
    </Grid>
  )
}
export default Info
